//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import './index.css'

import { ThemeProvider } from '@mui/material'
import CssBaseLine from '@mui/material/CssBaseline'
import React from 'react'
import { theme } from './components/theme'

import { createRoot } from 'react-dom/client'

import Footer from './components/Footer'

import { LicenseInfo } from '@mui/x-license-pro'
import { setupStoreWithInitialState, setupStoreWithInitialStateWithChainConnection } from '@react/redux/store'
import { Provider } from 'react-redux'
import { AlertWrapper } from './components/alerts/AlertWrapper'
import { AppKitListener } from './components/AppKitListener'
import { WebsocketProvider } from './components/WebSocketProvider'
import { LytIssuerOrProtocolManagerApp } from './lyt/protocolManager/LytIssuerOrProtocolManagerApp'
import { ExchangeRateProvider } from './hooks'

const root = createRoot(document.getElementById('root') as HTMLElement)
const isLocalHost = location.hostname === 'localhost'
LicenseInfo.setLicenseKey(
  '4aa820c74354bf0194df6f7dfa013a7fTz0xMTE4ODYsRT0xNzc3MDc1MTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
)
setupStoreWithInitialStateWithChainConnection(setupStoreWithInitialState()).then((initializedStore) => {
  root.render(
    <React.StrictMode>
      <div
        className="app-container"
        style={{
          height: '100%',
          minHeight: '100vh',
          backgroundColor: theme.palette.background.canvas,
        }}
      >
        <ThemeProvider theme={theme}>
          <CssBaseLine />
          <Provider store={initializedStore}>
            <ExchangeRateProvider>
              <AlertWrapper>
                {/* <Typography variant="h1">OpenTrade upgrade in progress...</Typography>
                <Typography variant="h1">It will take a few minutes to complete.</Typography> */}
                <WebsocketProvider>
                  <LytIssuerOrProtocolManagerApp />
                  {!isLocalHost && <AppKitListener />}
                </WebsocketProvider>
              </AlertWrapper>
            </ExchangeRateProvider>
          </Provider>
          <Footer />
        </ThemeProvider>
      </div>
    </React.StrictMode>
  )
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(logOT.debug))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals()
